export enum SectionActionUiEnum {
  COPY = 'COPY',
  DELETE = 'DELETE',
  EXTERNAL_COPY = 'EXTERNAL_COPY',
  OPEN_SETTINGS = 'OPEN_SETTINGS',
}
